import {PayloadAction} from "@reduxjs/toolkit";
import {Dispatch} from "react";
import {ProductSalesService} from "../service/Order/ProductSalesService";
import {ProductSalesReportParams} from "../shared/entities/Order/ProductSales";

export class ProductSalesController {
    private service: ProductSalesService;

    constructor(dispatch: Dispatch<PayloadAction<unknown>>) {
        this.service = new ProductSalesService(dispatch);
    }

    public async report(params: ProductSalesReportParams) {
        return this.service.report(params);
    }
}
